import axios from 'axios'
import { Message } from 'element-ui'

// 开发环境使用代理路径避免跨域触发浏览器跟踪防护
// 生产环境直连外部服务
const cudaApiBase = process.env.NODE_ENV === 'development'
  ? '/cuda-api'
  : 'http://8.155.53.4:6084'

export const BaseURL = cudaApiBase + '/cudaOnline'
export { cudaApiBase }

const Status = axios.create({
  baseURL: cudaApiBase,
  timeout: 5000
})

// 添加请求拦截器
Status.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  return config
}, function (error) {
  // 对请求错误做些什么
  Message.error('请求出错')
  console.error(error)
  return Promise.reject(error)
})

//  添加响应拦截器
Status.interceptors.response.use(response => {
  if (response.status && response.status !== 200) {
    console.error('response', response)
    throw new Error('服务错误')
  }

  return response.data
}, error => {
  // GPU监控为辅助功能，网络错误/CORS静默处理，不弹Message打扰用户
  console.warn('[cudaOnline] 请求失败:', error.message || error)
  return Promise.reject(error)
})

export default Status
